import { useEffect, useState } from 'react';
import { temaClaro } from '../../styles/tema';
import TooltipText from '../TooltipText';
import { Conteiner, TextArea } from './styles';

export function Botao({
  children,
  aoClicar,
  cor = 'primary',
  texto = null,
  tipo = 'button',
  dica = null,
  outlined = false,
  desabilitado = false,
  id,
}) {
  const [modoEscuro, atribuirModoEscuro] = useState(false);

  useEffect(() => {
    let corHex = temaClaro[cor.toUpperCase()];

    if (corHex) {
      corHex = corHex.replace('#', '');
      const rgb = [corHex.substring(0, 2), corHex.substring(2, 4), corHex.substring(4, 6)];
      let soma = Math.round(
        (parseInt(rgb[0], 16) * 299 + parseInt(rgb[1], 16) * 587 + parseInt(rgb[2], 16) * 114) /
          1000,
      );
      atribuirModoEscuro(soma > 128);
    }
  }, [cor]);

  return (
    <Conteiner
      onClick={aoClicar}
      $cor={cor.toUpperCase()}
      $modoEscuro={modoEscuro}
      type={tipo}
      $outlined={outlined}
      disabled={desabilitado}
      id={`botao-${id}`}
    >
      {children}
      {texto ? (
        <TextArea $modoEscuro={modoEscuro} $outlined={outlined}>
          {texto}
        </TextArea>
      ) : null}
      {dica && <TooltipText>{dica}</TooltipText>}
    </Conteiner>
  );
}
